import { render, staticRenderFns } from "./RecordBox.vue?vue&type=template&id=a270350a&scoped=true"
import script from "./RecordBox.vue?vue&type=script&lang=js"
export * from "./RecordBox.vue?vue&type=script&lang=js"
import style0 from "./RecordBox.vue?vue&type=style&index=0&id=a270350a&prod&lang=scss&scoped=true"
import style1 from "./RecordBox.vue?vue&type=style&index=1&id=a270350a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a270350a",
  null
  
)

export default component.exports